export default "{\n    \"noDataMessage\": \"There is no data available.\"\n}\n"